import globalthis from 'globalthis/polyfill'
try {
  if (window && !window.globalThis) {
    window.globalThis = globalthis()
  }
} catch (err) {
  console.error(err)
}
